import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { FacetResponse } from './facet-response.type';
import { SearchResultItemDto } from './search-result-item-dto.type';

const SearchEntityResultDto = t.type(
  {
    entityType: nullable(t.string),
    count: nullable(t.number),
    values: nullable(t.array(SearchResultItemDto)),
    facets: nullable(t.array(FacetResponse)),
  },
  'SearchEntityResultDto ',
);

type SearchEntityResultDto = t.TypeOf<typeof SearchEntityResultDto>;
export { SearchEntityResultDto };
